import { render } from "./TotalCost.vue?vue&type=template&id=40126efc"
import script from "./TotalCost.vue?vue&type=script&lang=js"
export * from "./TotalCost.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__